import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const [formData, setFormData] = useState({ name: '', email: '', company: '', message: '' });
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('您的合作意向已提交成功，我们会尽快与您联系。');
      setFormData({ name: '', email: '', company: '', message: '' });
      return;
    }
    if (formData.message.length > 500) {
      setFormStatus('error');
      setFormMessage('留言内容不能超过500个字符。');
      return;
    }
    setFormStatus('loading');
    setFormMessage('');
    try {
      const fd = new FormData(form);
      const res = await fetch(form.getAttribute('action') || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }
      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('您的合作意向已提交成功，我们会尽快与您联系。');
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';
        if (serverMsg.toLowerCase().includes('spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后再试。');
        } else {
          setFormStatus('error');
          setFormMessage(serverMsg || '提交失败，请稍后重试。');
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <nav className="w-full bg-background-100 border-b border-background-200/70" aria-label="面包屑导航">
          <div className="w-full px-4 md:px-6 py-3">
            <ol className="flex items-center gap-2 text-sm text-foreground-600">
              <li><Link to="/" className="hover:text-primary-600 transition-colors">首页</Link></li>
              <li><div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line text-xs text-foreground-400" /></div></li>
              <li className="text-foreground-900 font-medium" aria-current="page">关于我们</li>
            </ol>
          </div>
        </nav>

        {/* Hero */}
        <section className="w-full bg-gradient-to-br from-primary-500 to-accent-500 text-white">
          <div className="w-full px-4 md:px-6 py-16 md:py-24 text-center">
            <h1 className="text-3xl md:text-5xl font-heading font-black mb-4">关于吃瓜黑料在线</h1>
            <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
              吃瓜黑料在线网站致力于打造最真实、最及时的吃瓜黑料内容聚合平台，为网友提供一站式吃瓜体验。
            </p>
          </div>
        </section>

        {/* Brand Intro */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">品牌介绍</h2>
              <div className="w-16 h-1 bg-primary-500 mx-auto rounded-full" />
            </div>
            <div className="space-y-6 text-foreground-700 leading-relaxed">
              <p>
                <strong>吃瓜黑料在线</strong>成立于2025年，是一个专注于网红塌房现场、博主反差视频及独家吃瓜爆料的中文内容聚合平台。我们以"实时更新、独家爆料"为核心理念，持续为用户带来最新最全的吃瓜资讯。
              </p>
              <p>
                我们的团队由资深媒体人、数据分析师和社交舆情监测专家组成，通过多渠道信息收集和交叉验证，确保每一条爆料内容的真实性和时效性。从51吃瓜网在线观看到91在线吃瓜，从黑料吃瓜在线到吃瓜黑料在线app，我们覆盖了全网最热门的吃瓜入口。
              </p>
              <p>
                作为国内领先的吃瓜黑料内容平台，我们日均更新超过50条独家爆料，累计服务用户超过千万人次。我们的内容涵盖网红塌房、明星八卦、社会热点、综艺争议等多个领域，是广大网民获取第一手爆料资讯的首选平台。
              </p>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full bg-background-100 border-y border-background-200/70">
          <div className="w-full px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-5xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                <div>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-1">1000万+</div>
                  <div className="text-sm text-foreground-600">月活用户</div>
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-accent-600 mb-1">50万+</div>
                  <div className="text-sm text-foreground-600">日均阅读</div>
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-secondary-600 mb-1">1000+</div>
                  <div className="text-sm text-foreground-600">独家爆料</div>
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-1">6大类</div>
                  <div className="text-sm text-foreground-600">内容分类</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">口碑与用户评价</h2>
              <div className="w-16 h-1 bg-primary-500 mx-auto rounded-full" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {[
                { name: '资深吃瓜群众', content: '用了半年多了，爆料速度真的很快，而且内容比较真实，不像别的网站全是标题党。', rating: 5 },
                { name: '娱乐资讯达人', content: '51吃瓜网在线观看看多了，发现还是这里的独家爆料最有料，更新也及时。', rating: 5 },
                { name: '吃瓜群众小王', content: '找黑料吃瓜在线内容的朋友推荐来的，果然没失望，界面清爽内容给力。', rating: 4 },
                { name: '八卦爱好者', content: '91在线吃瓜老用户了，这里的文章写得更详细，不是那种一两句就完事的。', rating: 5 },
              ].map((review, idx) => (
                <div key={idx} className="bg-background-50 rounded-lg border border-background-200/60 p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className={`ri-star-fill text-sm ${i < review.rating ? 'text-accent-500' : 'text-background-300'}`} />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">"{review.content}"</p>
                  <p className="text-xs text-foreground-500 font-medium">—— {review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full bg-background-100 border-y border-background-200/70">
          <div className="w-full px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">联系我们</h2>
                <div className="w-16 h-1 bg-primary-500 mx-auto rounded-full" />
                <p className="text-sm text-foreground-600 mt-3">如果您有任何问题、爆料线索或合作意向，欢迎随时联系我们</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-full mb-3">
                    <i className="ri-mail-line text-xl text-primary-600" />
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1">内容投稿</h3>
                  <p className="text-sm text-foreground-600">contact@chiguaheiliaozx.com</p>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center bg-accent-100 rounded-full mb-3">
                    <i className="ri-briefcase-line text-xl text-accent-600" />
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1">商务合作</h3>
                  <p className="text-sm text-foreground-600">biz@chiguaheiliaozx.com</p>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center bg-secondary-100 rounded-full mb-3">
                    <i className="ri-shield-check-line text-xl text-secondary-600" />
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1">侵权投诉</h3>
                  <p className="text-sm text-foreground-600">dmca@chiguaheiliaozx.com</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Business Cooperation Form */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">商务合作洽谈</h2>
              <div className="w-16 h-1 bg-primary-500 mx-auto rounded-full" />
              <p className="text-sm text-foreground-600 mt-3">留下您的合作意向，我们会在24小时内与您取得联系</p>
            </div>
            <form
              onSubmit={handleSubmit}
              action="https://readdy.ai/api/form/d96ea670d76aer3t53i0"
              method="POST"
              data-readdy-form
              className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8 space-y-5"
            >
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <div>
                <label htmlFor="biz-name" className="block text-sm font-medium text-foreground-700 mb-1.5">您的姓名 <span className="text-primary-500">*</span></label>
                <input
                  id="biz-name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="请输入您的姓名"
                  required
                  className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <label htmlFor="biz-email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱 <span className="text-primary-500">*</span></label>
                <input
                  id="biz-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="请输入您的电子邮箱"
                  required
                  className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <label htmlFor="biz-company" className="block text-sm font-medium text-foreground-700 mb-1.5">公司/机构名称</label>
                <input
                  id="biz-company"
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="请输入您的公司或机构名称"
                  className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <label htmlFor="biz-message" className="block text-sm font-medium text-foreground-700 mb-1.5">合作意向说明 <span className="text-primary-500">*</span></label>
                <textarea
                  id="biz-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="请简要描述您的合作意向（限500字）"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                />
                <p className="text-xs text-foreground-500 mt-1 text-right">{formData.message.length}/500</p>
              </div>

              {formMessage && (
                <div className={`p-3 rounded-lg text-sm ${
                  formStatus === 'success' ? 'bg-primary-100 text-primary-800' : 'bg-accent-100 text-accent-800'
                }`}>
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={formStatus === 'success' ? 'ri-checkbox-circle-fill' : 'ri-error-warning-fill'}></i>
                    </div>
                    <span>{formMessage}</span>
                  </div>
                </div>
              )}

              <button
                type="submit"
                disabled={formStatus === 'loading'}
                className="w-full px-6 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
              >
                {formStatus === 'loading' ? '提交中...' : '提交合作意向'}
              </button>
            </form>
          </div>
        </section>

        {/* Disclaimer */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">免责声明</h2>
              <div className="w-16 h-1 bg-primary-500 mx-auto rounded-full" />
            </div>
            <div className="bg-background-100 rounded-lg p-6 md:p-8 text-sm text-foreground-600 leading-relaxed space-y-4">
              <p>
                1. 本站所有内容均来源于网络公开信息和网友爆料整理，仅供娱乐参考，不代表本站立场和观点。
              </p>
              <p>
                2. 本站内容可能包含未经核实的信息，请读者理性看待，切勿轻信或传播不实信息。
              </p>
              <p>
                3. 如相关内容涉及侵权，请权利人通过上述侵权投诉渠道联系我们，我们将第一时间核实并处理。
              </p>
              <p>
                4. 用户在使用本站服务时，应遵守中华人民共和国相关法律法规，不得利用本站从事违法违规活动。
              </p>
              <p>
                5. 本站保留随时修改或中断服务而不需通知用户的权利，同时保留修改免责声明条款的权利。
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://chiguaheiliaozx.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://chiguaheiliaozx.com/about' },
            ],
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 吃瓜黑料在线',
            description: '吃瓜黑料在线网站致力于打造最真实、最及时的吃瓜黑料内容聚合平台。',
            url: 'https://chiguaheiliaozx.com/about',
            isPartOf: { '@type': 'WebSite', name: '吃瓜黑料在线' },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '吃瓜黑料在线',
            url: 'https://chiguaheiliaozx.com',
            description: '吃瓜黑料在线网站提供最新的网红塌房、明星八卦、独家爆料等内容，打造实时更新的吃瓜黑料聚集平台。',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: '客户服务',
              email: 'contact@chiguaheiliaozx.com',
            },
          }),
        }}
      />
    </>
  );
}